module.exports = __webpack_public_path__ + "img/CREDIT2.de396f0a.png";